import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { font18 } from 'approot/shared/styles/typography.style';
import {
  boxShadowBlack12,
  standardBorderRadius,
} from 'approot/shared/styles/borders.style';
import {
  spacing8,
  spacing12,
  spacing16,
  spacing40,
} from 'approot/shared/styles/spacing.style';
import { purple1, purple8 } from 'approot/shared/styles/colours.style';
import { Box } from 'approot/shared/design-system/box/box.style';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';

type Props = {
  $backgroundColor?: string;
  $textColor?: string;
  $top?: number;
};

export const DismissableSnackbarContainer = styled.div<Props>`
  display: flex;
  align-items: center;
  ${boxShadowBlack12}
  animation: slideUp 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  top: ${props => `${props.$top ? rem(props.$top) : 'auto'}`};
  padding: ${rem(spacing12)} ${rem(spacing16)};
  ${standardBorderRadius};
  color: ${props => props.$textColor || 'inherit'};
  background-color: ${props => props.$backgroundColor || purple1};
  max-width: ${rem(636)};
  z-index: 111; // display above modals, scroll to top, fixed footer nav

  ${font18}

  @keyframes slideUp {
    0% {
      transform: translate(-50%, 100%);
    }
    100% {
      transform: translate(-50%, -100%);
    }
  }
`;

export const DismissableSnackbarContent = styled(Box).attrs({
  $alignItems: 'center',
  $gap: 16,
  $flexWrap: 'nowrap',
})`
  padding-right: ${rem(spacing40)}; /* Make room for close button */
`;

export const DismissableSnackbarText = styled.span`
  color: ${purple8};
  white-space: nowrap;
`;

export const DismissableSnackbarCloseButton = styled(SecondaryButtonIcon)`
  background-color: transparent;
  border: none;
  border-radius: 100%;
  position: absolute;
  right: ${rem(spacing8)};
  top: ${rem(spacing12)};
  cursor: pointer;
`;
